export default "__VITE_ASSET__BA3LCjdD__"